import React from 'react'

const ExtensionPromotion = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 272 184"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_55_4366)">
        <g filter="url(#filter0_d_55_4366)">
          <g clipPath="url(#clip1_55_4366)">
            <path
              d="M0 0H256C264.837 0 272 7.16344 272 16V184H0V0Z"
              fill="white"
            />
            <rect width="272" height="48" fill="#F5F5F5" />
            <rect
              width="16"
              height="16"
              transform="translate(0 32)"
              fill="white"
            />
            <path d="M0 32H16C16 40.8366 8.83656 48 0 48V32Z" fill="#F5F5F5" />
            <path
              d="M16 20C16 11.1634 23.1634 4 32 4H103C111.837 4 119 11.1634 119 20V48H16V20Z"
              fill="white"
            />
            <path
              d="M37.3499 34V22.624H44.6779V23.968H38.8219V27.456H43.8779V28.752H38.8219V32.656H44.7579V34H37.3499ZM46.4593 34V22.624H47.9313V27.424H53.5313V22.624H55.0033V34H53.5313V28.8H47.9313V34H46.4593ZM57.5374 34V22.576H61.5854C64.7374 22.576 66.1134 23.28 66.1134 26.16C66.1134 28.224 65.4094 29.152 63.8414 29.52L66.2574 34H64.6734L62.4654 29.696C62.1774 29.712 61.8734 29.712 61.5534 29.712H59.0094V34H57.5374ZM59.0094 23.904V28.4H61.4574C63.3934 28.4 64.6094 28.192 64.6094 26.16C64.6094 24.112 63.3934 23.904 61.4574 23.904H59.0094Z"
              fill="#C9C9C9"
            />
            <g opacity="0.5">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M95.6569 22.3431L94.2426 23.7574L98.4853 28L94.2426 32.2426L95.6569 33.6569L99.8995 29.4142L104.142 33.6569L105.556 32.2426L101.314 28L105.556 23.7574L104.142 22.3431L99.8995 26.5858L95.6569 22.3431Z"
                fill="#C9C9C9"
              />
            </g>
            <rect
              width="16"
              height="16"
              transform="translate(119 32)"
              fill="white"
            />
            <path
              d="M119 32H135V48C126.163 48 119 40.8366 119 32Z"
              fill="#F5F5F5"
            />
            <rect
              width="272"
              height="48"
              transform="translate(0 48)"
              fill="white"
            />
            <path
              d="M0 56H138C146.837 56 154 63.1634 154 72C154 80.8366 146.837 88 138 88H0V56Z"
              fill="#F5F5F5"
            />
            <rect x="178" y="64" width="16" height="16" rx="8" fill="white" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M181.524 65.2022C181.511 65.4923 181.536 73.5732 181.653 74.5637C181.826 76.0263 182.523 77.2503 183.604 78.0465C183.763 78.2068 183.788 78.4638 183.652 78.652C183.564 78.774 183.422 78.8463 183.272 78.8463C183.172 78.8463 183.076 78.8184 182.997 78.7574C181.309 77.4515 180.794 75.7528 180.718 74.1255C180.718 74.1255 180.642 66.3042 180.675 65.1255L180.677 65.0715C180.677 64.4826 181.289 64 181.924 64H181.984C182.62 64 183.324 64.4852 183.323 65.0802C183.316 65.4106 183.315 66.4912 183.314 67.5966C183.314 68.3802 183.313 69.1761 183.31 69.7261C184.213 69.0954 185.268 68.7644 186.377 68.7644C186.62 68.7644 186.865 68.7809 187.106 68.8131C187.268 68.8349 187.431 68.8654 187.592 68.902C187.844 68.9604 188.001 69.2121 187.944 69.4639C187.885 69.7148 187.634 69.8725 187.383 69.8158C187.249 69.7854 187.114 69.761 186.98 69.7427C186.782 69.7165 186.58 69.7026 186.377 69.7026C185.228 69.7026 184.141 70.1399 183.307 70.9362C183.31 72.8954 183.343 74.2378 183.4 74.6246C183.568 75.8434 184.67 77.1475 186.379 77.1675C186.614 77.1675 186.85 77.1405 187.076 77.0865C187.33 77.0282 187.58 77.1832 187.641 77.4341C187.7 77.6859 187.545 77.9385 187.293 77.9986C184.655 78.429 182.687 76.7503 182.434 74.4487C182.305 73.2735 182.395 65.4845 182.407 65.244C182.417 65.0001 182.229 64.7936 181.987 64.7823C181.869 64.7762 181.756 64.8171 181.669 64.8964C181.582 64.9757 181.53 65.0846 181.524 65.2022ZM190.347 70.3821C190.255 70.2898 190.132 70.2384 190.001 70.2375H189.994C189.866 70.2384 189.745 70.2898 189.654 70.3804C189.462 70.5711 189.461 70.8821 189.652 71.0738C190.513 71.9389 190.995 73.0888 191.008 74.3101C191.035 76.8792 188.967 78.9917 186.398 79.0196C186.13 79.0222 185.861 79.0022 185.597 78.9595C185.329 78.9177 185.078 79.0998 185.035 79.3655C185.014 79.4944 185.045 79.6242 185.121 79.7305C185.198 79.8368 185.311 79.9065 185.44 79.9274C185.758 79.9788 186.084 80.0032 186.408 79.9997C189.517 79.9666 192.021 77.4089 191.987 74.2988C191.973 72.8222 191.39 71.4301 190.347 70.3821ZM188.371 76.2563C188.196 76.4244 188.191 76.7023 188.358 76.8766C188.44 76.9619 188.556 77.0116 188.675 77.0116C188.789 77.0116 188.897 76.968 188.979 76.8888C189.604 76.2859 189.886 75.6369 189.985 74.7806C189.985 74.7806 189.987 74.757 189.988 74.757C189.993 74.717 189.996 74.6769 190.001 74.6185L190.011 74.3711L190.012 74.3476L190.008 74.1934C190.006 74.1472 190.002 74.1011 189.999 74.0549L189.996 74.0218C189.838 72.2194 188.357 70.7732 186.53 70.6565L186.525 70.6563C186.488 70.6546 186.452 70.653 186.417 70.6522L186.338 70.6504L186.313 70.6495L186.275 70.6504C186.216 70.6504 186.158 70.653 186.101 70.6565L186.042 70.66C185.977 70.6652 185.91 70.6713 185.844 70.68L185.818 70.6826C185.747 70.6922 185.675 70.7044 185.603 70.7184L185.53 70.734C185.487 70.7429 185.445 70.7533 185.389 70.7672L185.375 70.7706L185.331 70.7828C185.248 70.8055 185.164 70.8307 185.081 70.8604C184.772 70.9693 184.479 71.1182 184.211 71.3029C184.114 71.3691 184.05 71.4693 184.029 71.5843C184.008 71.7002 184.032 71.816 184.099 71.9127C184.166 72.0094 184.267 72.0739 184.382 72.0948C184.497 72.1166 184.613 72.0913 184.71 72.0242C184.914 71.884 185.137 71.7707 185.374 71.6871C185.453 71.6592 185.532 71.6357 185.613 71.6157C185.646 71.6069 185.68 71.5991 185.714 71.5921L185.734 71.5878L185.773 71.5799C185.826 71.5695 185.881 71.5608 185.934 71.5529L185.958 71.5503C186.006 71.5442 186.056 71.539 186.104 71.5355L186.15 71.5329C186.194 71.5303 186.238 71.5294 186.3 71.5285H186.329L186.485 71.5338C187.62 71.6035 188.594 72.3405 188.972 73.4085C189.067 73.6777 189.121 73.9573 189.132 74.2361L189.133 74.2622C189.134 74.2997 189.135 74.3371 189.135 74.3763L189.134 74.4112L189.134 74.4122C189.133 74.4476 189.132 74.484 189.129 74.5393C189.102 74.9121 189.003 75.2736 188.832 75.6134C188.826 75.6256 188.822 75.6369 188.824 75.6378C188.68 75.9131 188.595 76.0403 188.371 76.2563Z"
              fill="#C9C9C9"
            />
            <path
              d="M217 67C217.187 67 217.333 67.1467 217.333 67.3333V68.6667H221.333V72.6667H222.667C222.853 72.6667 223 72.8133 223 73C223 73.1867 222.853 73.3333 222.667 73.3333H221.333V77.3333H219.92C219.467 76.1667 218.327 75.3333 217 75.3333C215.673 75.3333 214.533 76.1667 214.08 77.3333H212.667V75.92C213.833 75.4667 214.667 74.3267 214.667 73C214.667 71.6733 213.84 70.5333 212.673 70.08L212.667 68.6667H216.667V67.3333C216.667 67.1467 216.813 67 217 67ZM217 65.6667C216.08 65.6667 215.333 66.4133 215.333 67.3333H212.667C211.933 67.3333 211.34 67.9333 211.34 68.6667V71.2H211.533C212.527 71.2 213.333 72.0067 213.333 73C213.333 73.9933 212.527 74.8 211.533 74.8H211.333V77.3333C211.333 78.0667 211.933 78.6667 212.667 78.6667H215.2V78.4667C215.2 77.4733 216.007 76.6667 217 76.6667C217.993 76.6667 218.8 77.4733 218.8 78.4667V78.6667H221.333C222.067 78.6667 222.667 78.0667 222.667 77.3333V74.6667C223.587 74.6667 224.333 73.92 224.333 73C224.333 72.08 223.587 71.3333 222.667 71.3333V68.6667C222.667 67.9333 222.067 67.3333 221.333 67.3333H218.667C218.667 66.4133 217.92 65.6667 217 65.6667Z"
              fill="#C9C9C9"
            />
            <rect
              x="242"
              y="64.5"
              width="3"
              height="3"
              rx="1.5"
              fill="#C9C9C9"
            />
            <rect
              x="242"
              y="70.5"
              width="3"
              height="3"
              rx="1.5"
              fill="#C9C9C9"
            />
            <rect
              x="242"
              y="76.5"
              width="3"
              height="3"
              rx="1.5"
              fill="#C9C9C9"
            />
            <rect
              width="272"
              height="88"
              transform="translate(0 96)"
              fill="url(#paint0_linear_55_4366)"
            />
            <g opacity="0.4" filter="url(#filter1_d_55_4366)">
              <rect
                x="104"
                y="112"
                width="152"
                height="56"
                rx="28"
                fill="#2D54E8"
              />
              <rect
                x="104.5"
                y="112.5"
                width="151"
                height="55"
                rx="27.5"
                stroke="#E4E5E6"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M125.287 129.803C125.267 130.238 125.303 142.36 125.48 143.845C125.74 146.039 126.784 147.875 128.406 149.07C128.645 149.31 128.683 149.696 128.478 149.978C128.347 150.161 128.134 150.269 127.908 150.269C127.759 150.269 127.614 150.228 127.496 150.136C124.964 148.177 124.191 145.629 124.078 143.188C124.078 143.188 123.963 131.456 124.012 129.688L124.015 129.607C124.015 128.724 124.934 128 125.886 128H125.976C126.93 128 127.986 128.728 127.985 129.62C127.974 130.116 127.973 131.737 127.972 133.395C127.971 134.57 127.97 135.764 127.965 136.589C129.32 135.643 130.902 135.147 132.566 135.147C132.931 135.147 133.298 135.171 133.659 135.22C133.902 135.252 134.147 135.298 134.388 135.353C134.766 135.441 135.002 135.818 134.916 136.196C134.828 136.572 134.451 136.809 134.074 136.724C133.874 136.678 133.672 136.641 133.471 136.614C133.174 136.575 132.869 136.554 132.566 136.554C130.843 136.554 129.212 137.21 127.961 138.404C127.965 141.343 128.015 143.357 128.1 143.937C128.352 145.765 130.005 147.721 132.569 147.751C132.922 147.751 133.275 147.711 133.614 147.63C133.995 147.542 134.371 147.775 134.461 148.151C134.55 148.529 134.317 148.908 133.94 148.998C129.983 149.643 127.031 147.125 126.651 143.673C126.457 141.91 126.593 130.227 126.61 129.866C126.626 129.5 126.344 129.19 125.98 129.173C125.804 129.164 125.634 129.226 125.503 129.345C125.373 129.464 125.296 129.627 125.287 129.803ZM138.521 137.573C138.383 137.435 138.198 137.358 138.002 137.356H137.992C137.8 137.358 137.618 137.435 137.481 137.571C137.193 137.857 137.192 138.323 137.478 138.611C138.769 139.908 139.492 141.633 139.512 143.465C139.553 147.319 136.451 150.488 132.598 150.529C132.195 150.533 131.791 150.503 131.396 150.439C130.993 150.377 130.617 150.65 130.553 151.048C130.521 151.242 130.567 151.436 130.682 151.596C130.797 151.755 130.967 151.86 131.16 151.891C131.637 151.968 132.126 152.005 132.612 152C137.276 151.95 141.031 148.113 140.98 143.448C140.96 141.233 140.085 139.145 138.521 137.573ZM135.556 146.384C135.295 146.637 135.287 147.054 135.538 147.315C135.661 147.443 135.834 147.517 136.012 147.517C136.183 147.517 136.345 147.452 136.468 147.333C137.406 146.429 137.829 145.455 137.978 144.171C137.978 144.171 137.981 144.136 137.983 144.136C137.989 144.075 137.995 144.015 138.001 143.928L138.017 143.557L138.018 143.521L138.012 143.29C138.009 143.221 138.004 143.152 137.998 143.082L137.995 143.033C137.757 140.329 135.535 138.16 132.795 137.985L132.787 137.984C132.733 137.982 132.679 137.979 132.625 137.978L132.508 137.976L132.47 137.974L132.413 137.976C132.325 137.976 132.237 137.98 132.152 137.985L132.063 137.99C131.965 137.998 131.866 138.007 131.767 138.02C131.767 138.02 131.757 138.021 131.747 138.022C131.737 138.023 131.728 138.024 131.727 138.024C131.62 138.038 131.513 138.057 131.405 138.078L131.295 138.101C131.231 138.114 131.168 138.13 131.083 138.151L131.062 138.156L130.997 138.174C130.872 138.208 130.746 138.246 130.622 138.291C130.158 138.454 129.719 138.677 129.316 138.954C129.171 139.054 129.075 139.204 129.043 139.376C129.012 139.55 129.049 139.724 129.149 139.869C129.249 140.014 129.4 140.111 129.573 140.142C129.746 140.175 129.92 140.137 130.065 140.036C130.371 139.826 130.706 139.656 131.061 139.531C131.18 139.489 131.299 139.454 131.419 139.423C131.469 139.41 131.52 139.399 131.571 139.388L131.602 139.382L131.659 139.37C131.739 139.354 131.822 139.341 131.901 139.329L131.938 139.325C132.01 139.316 132.084 139.308 132.156 139.303L132.225 139.299C132.292 139.295 132.357 139.294 132.45 139.293H132.494L132.728 139.301C134.43 139.405 135.892 140.511 136.458 142.113C136.6 142.517 136.681 142.936 136.698 143.354L136.7 143.393C136.701 143.45 136.702 143.506 136.702 143.565L136.701 143.617L136.701 143.618V143.618C136.7 143.671 136.698 143.726 136.693 143.809C136.654 144.368 136.505 144.91 136.249 145.42C136.24 145.438 136.233 145.455 136.236 145.457C136.02 145.87 135.893 146.06 135.556 146.384Z"
                fill="white"
              />
              <rect
                x="160"
                y="120"
                width="40"
                height="40"
                rx="20"
                fill="white"
              />
              <mask
                id="mask0_55_4366"
                maskUnits="userSpaceOnUse"
                x="173"
                y="131"
                width="14"
                height="19"
              >
                <path
                  d="M180 143C181.66 143 182.99 141.66 182.99 140L183 134C183 132.34 181.66 131 180 131C178.34 131 177 132.34 177 134V140C177 141.66 178.34 143 180 143ZM185.3 140C185.3 143 182.76 145.1 180 145.1C177.24 145.1 174.7 143 174.7 140H173C173 143.42 175.72 146.23 179 146.72V150H181V146.72C184.28 146.24 187 143.42 187 140H185.3Z"
                  fill="#282828"
                />
              </mask>
              <g mask="url(#mask0_55_4366)">
                <rect x="171.5" y="131" width="17" height="20" fill="#282828" />
                <path
                  d="M176 137H183V142C183 143.105 182.105 144 181 144H178C176.895 144 176 143.105 176 142V137Z"
                  fill="#68E19F"
                />
              </g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M229 137.586L230.414 139L234.071 135.343V138H236.071V134V132H234.071H230.071L230.071 134L232.586 134L229 137.586ZM227.071 142.414L225.657 141L222 144.657V142H220V146V148H222H226V146H223.485L227.071 142.414Z"
                fill="white"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_55_4366"
          x="-4"
          y="-2"
          width="280"
          height="192"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_55_4366"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_55_4366"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_55_4366"
          x="96"
          y="106"
          width="168"
          height="72"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_55_4366"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_55_4366"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_55_4366"
          x1="136"
          y1="88"
          x2="136"
          y2="1.45218e-06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5F5F5" stopOpacity="0" />
          <stop offset="1" stopColor="#F5F5F5" />
        </linearGradient>
        <clipPath id="clip0_55_4366">
          <rect width="272" height="184" fill="white" />
        </clipPath>
        <clipPath id="clip1_55_4366">
          <path
            d="M0 0H256C264.837 0 272 7.16344 272 16V184H0V0Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ExtensionPromotion
